import { LayoutState } from "../layout.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { SidebarLayout } from "../types/sidebar.ts";

export const setSidebarReducer = (
  state: LayoutState,
  action: PayloadAction<SidebarLayout>,
) => {
  state.sidebar = action.payload;
};
